import { useState, useEffect } from "react";
import { useAttemptedQuestions } from "../../context/AttemptedQuestionsContext";
import { decryptData } from "../../crypto";
import { useQuestionRecord } from "../../context/QuestionRecord";

export const useQuestionNavigator = ({ questionData, currentQuestion }) => {
  const [questions, setQuestions] = useState([]);
  const [answered, setAnswered] = useState(0);
  const [marked, setMarked] = useState(0);
  const [notVisited, setNotVisited] = useState(0);
  const [notAnswered, setNotAnswered] = useState(0);
  const [markedWithAnswered, setMarkedWithAnswered] = useState(0);
  const [visitedQuestions, setVisitedQuestions] = useState([0]);

  const { attemptedQuestions } = useAttemptedQuestions();
  const { addQuestionRecord, questionRecords, getQuestionRecordById } =
    useQuestionRecord();

  // Initialize questions
  useEffect(() => {
    if (!questionData || questions.length) return;

    const initialQuestions = questionData.map((q, idx) => ({
      section_id: q.section_id,
      subject_id: q.subject_id,
      number: idx + 1,
      status: "notVisited",
    }));
    setQuestions(initialQuestions);
  }, [questionData, questionRecords]);

  useEffect(() => {
    if (!attemptedQuestions) return;
    attemptedQuestions?.map((question) => {
      addQuestionRecord(question);
    });
  }, [attemptedQuestions]);

  // Track visited questions
  useEffect(() => {
    setVisitedQuestions((prev) => {
      const isAlreadyVisited = prev.includes(currentQuestion);
      const questionStatus = questions?.[currentQuestion]?.status;

      if (!isAlreadyVisited && questionStatus === "notVisited") {
        return [...prev, currentQuestion];
      }
      return prev;
    });
  }, [currentQuestion, questions]);

  // Update question statuses based on attempted questions
  useEffect(() => {
    const updatedQuestions = questions?.map((q, idx) => {
      // const matched = attemptedQuestions?.find(
      //   (aq) => Number(aq.question_id) === Number(questionData[idx]?.id)
      // );
      const matched = questionRecords?.find(
        (aq) => Number(aq.question_id) === Number(questionData[idx]?.id)
      );

      let newStatus = q.status;

      if (decryptData(sessionStorage.getItem("exam_template")) !== "default") {
        if (visitedQuestions.includes(idx) && !matched) {
          newStatus = "notAnswered";
        }
      }

      if (matched) {
        if (matched.attempt_status === "attempted") {
          newStatus = "attempted";
        }
        if (
          matched.attempt_status === "attempted" &&
          matched.multiple_option_ids?.length === 0
        ) {
          newStatus = "notAnswered";
        }
        if (
          matched.attempt_status === "not answered" &&
          (!matched.option_id ||
            !matched.multiple_option_ids ||
            matched.multiple_option_ids?.length === 0)
        ) {
          newStatus = "notAnswered";
        }
        if (matched.attempt_status === "marked" && matched.option_id) {
          newStatus = "markedWithAnswered";
        }
        if (matched.attempt_status === "marked" && !matched.option_id) {
          newStatus = "marked";
        }
        if (
          matched.attempt_status === "marked" &&
          !matched.option_id &&
          matched.multiple_option_ids?.length > 0
        ) {
          newStatus = "markedWithAnswered";
        }
      }

      return q.status !== newStatus ? { ...q, status: newStatus } : q;
    });

    const isDifferent = updatedQuestions.some(
      (q, idx) => q.status !== questions[idx].status
    );

    if (isDifferent) {
      setQuestions(updatedQuestions);
    }
  }, [attemptedQuestions, visitedQuestions, questionRecords, questionData]);

  // Calculate and update counts
  useEffect(() => {
    let answeredCount = 0;
    let markedCount = 0;
    let markedWithAnsweredCount = 0;
    let visitedQuestionsCount = 0;

    questions?.forEach((q) => {
      if (q.status === "attempted") answeredCount++;
      else if (q.status === "markedWithAnswered") markedWithAnsweredCount++;
      else if (q.status === "marked") markedCount++;
      else if (q.status === "notAnswered") visitedQuestionsCount++;
    });

    let notVisitedCount =
      questionData?.length -
      (answeredCount +
        markedCount +
        markedWithAnsweredCount +
        visitedQuestionsCount);

    // if(visitedQuestionsCount===questions.length){
    //   notVisitedCount = 0
    //   visitedQuestionsCount = questions.length
    // }else{

    //   visitedQuestionsCount = visitedQuestionsCount > 0 ? visitedQuestionsCount - 1 : 0

    // }

    setAnswered(answeredCount);
    setMarked(markedCount);
    setMarkedWithAnswered(markedWithAnsweredCount);
    setNotAnswered(visitedQuestionsCount);
    setNotVisited(notVisitedCount);
  }, [questions, questionData?.length]);

  return {
    questions,
    answered,
    marked,
    notVisited,
    notAnswered,
    markedWithAnswered,
    visitedQuestions,
  };
};
